module.exports = __webpack_public_path__ + "static/media/mining-indust.04a5cf05.webp";